import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { ArticleStatus } from "./ProgressBadge";
type StatusValue = "all" | ArticleStatus;

interface StatusFilterProps {
  value?: StatusValue | string;
  onValueChange: (value: StatusValue) => void;
  placeholder?: string;
  className?: string;
}
const statusOptions = [
  { value: "all", label: "All Articles" },
  { value: "draft", label: "Draft" },
  { value: "in_progress", label: "Generating" },
  { value: "completed", label: "Completed" },
  { value: "failed", label: "Failed" },
  { value: "published", label: "Published" },
  { value: "scheduled", label: "Scheduled" },
];

export function StatusFilter({
  value = "all",
  onValueChange,
  placeholder = "Filter by status",
  className,
}: StatusFilterProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <div className="flex items-center gap-2">
          <FontAwesomeIcon
            icon={faFilter}
            className="h-4 w-4 text-muted-foreground"
          />
          <SelectValue placeholder={placeholder} />
        </div>
      </SelectTrigger>
      <SelectContent>
        {statusOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default StatusFilter;
